import { CountryIssue, Currency } from '@moment/trading-types/reference-data'

export const AVAILABLE_COUNTRY_ISSUE = Object.values(
  CountryIssue,
) as CountryIssue[]

export const AVAILABLE_CURRENCY = Object.values(Currency) as Currency[]

export const CURRENCY_SYMBOLS: Record<string, string> = {
  [Currency.USD]: '$',
  [Currency.GBP]: '£',
  [Currency.EUR]: '€',
  [Currency.CHF]: 'CHF',
  [Currency.AUD]: 'A$',
}
